module.exports = FormData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/isomorphic-form-data/lib/browser.js
// module id = 910
// module chunks = 0